// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2ZIiG","overflowing":"ReadFullNote_overflowing__13EHY"};